<template>
  <div>
    <!-- <div v-if="
      ($auth.policies['financial-report'])
    "> -->
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          :headline="route.meta.title"
          :link="[{ text: 'Tài chính', href: '#' }, { text: route.meta.title }]"
        />
      </div>
      <div class="flex-center">
        <ExportExcel />
      </div>
    </div>
    <v-card outlined class="pa-9 mx-4 mb-6 elevation-0">
      <FinancialReportFilter />
    </v-card>
    <v-card outlined class="mx-4 elevation-0">
      <TableFinancialReport />
    </v-card>
    <div class="d-flex justify-end ma-4" v-if="totalHeadFee.length > 0">
      <router-link :to="`/tuition-fee-detail-period/${period.id}`" class="text-decoration-none">
        <p class="detail_period_text">Xem chi tiết kỳ đóng</p>
      </router-link>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import FinancialReportFilter from '@/modules/tuitionFee/financial-report/FinancialReportFilter.vue'
import TableFinancialReport from '@/modules/tuitionFee/financial-report/TableFinancialReport.vue'
import ExportExcel from '@/modules/tuitionFee/financial-report/ExportExcel.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
// import Page403 from '@/views/Page403.vue'
export default {
  components: {
    Breadcrumbs,
    FinancialReportFilter,
    TableFinancialReport,
    ExportExcel
    // Page403
  },
  computed: {
    ...mapGetters({
      totalHeadFee: 'tuitionFeeReport/totalHeadFee',
      period: 'tuitionFeeReport/period'
    }),
    ...mapState('tuitionFeeGroup', ['tuitionFeeGroups', 'tuitionFeeSearchParams']),
    route() {
      return this.$route
    },
    type() {
      if (this.route.name === 'TuitionFeeGroup') return 'normal'
      else return 'priority'
    }
  },
  async created() {
    await this.fetchPeriods()
  },
  methods: {
    ...mapActions('tuitionFeePeriod', ['fetchPeriods'])
  }
}
</script>
<style lang="scss" scoped>
td {
  white-space: nowrap !important;
}
.detail_period_text {
  // cursor: pointer;
  text-decoration: none;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #0d47a1;
}
</style>
